<template>
  <div class="numbercard-chart">
    <div class="dashboard-chart-card">
      <h2 v-html="firsttitle"></h2>
      <h3 class="text-number" v-if="!nodata">
        <span v-if="!subid">{{ firstnumber }}</span>
        <el-button v-if="subid" type="text" @click="viewLowPricedLinks(subid)">{{ firstnumber }}</el-button>
      </h3>
      <h4 v-if="!nodata">{{ firstunit }}</h4>
      <div v-if="nodata" class="numbercard-chart-empty numbercard-chart-empty-bg1"></div>
    </div>
    <div class="dashboard-chart-div-line"></div>
    <div class="dashboard-chart-card">
      <h2>{{ secondtitle }}</h2>
      <h3 class="text-percent" v-if="!nodata">{{ secondnumber }}</h3>
      <h4 v-if="!nodata">{{ secondunit }}</h4>
      <div v-if="nodata" class="numbercard-chart-empty numbercard-chart-empty-bg2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberCard',
  props: ['firsttitle', 'secondtitle', 'firstunit', 'secondunit', 'firstnumber', 'secondnumber', 'nodata', 'subid', 'routename'],
  methods: {
    viewLowPricedLinks: function(subid){
      this.$router.push({name: this.routename, params: {Id: subid}})
    },
  }
}
</script>

<style scoped>
.numbercard-chart{
  width: auto;
}
.numbercard-chart-empty{
  width: 100%;
  height: 110px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80px auto;
}
.numbercard-chart-empty-bg1{
  background-image: url('../../assets/img/numbercardnodata01.svg');
}
.numbercard-chart-empty-bg2{
  background-image: url('../../assets/img/numbercardnodata02.svg');
}
</style>